<template>
  <div>
    <L1>
      <template slot="slot_title">
        <Select1 :width="'185px'" :defaultValue="country" @input="country=$event">
          <option :value="null">縣市</option>
          <option v-for="(cc, i) in countries" :key="`country-${i}`" :value="cc">{{cc}}</option>
        </Select1>
        <search :width="'300px'" :defaultValue="searchText" @input="searchText=$event"/>
        <round :icon="'add'" :text="'新增合作代理'" :bg="'var(--color-checked)'" @click="selected=null;add=!add"></round>
        <page-50 :style="{marginLeft: 'auto'}" :defaultValue="page" @input="page=$event" :max="max"></page-50>
        <round :icon="'pen'" :text="'編輯類別'" :bg="'var(--color-checked)'" @click="editCates=!editCates"></round>
      </template>
      <T2 :rows="rows">
        <template slot="slot_head">
          <th :style="{textAlign: 'start', width: '8em'}">類別</th>
          <th :style="{textAlign: 'start', width: '15em'}">名稱</th>
          <th :style="{textAlign: 'start', width: '14em'}">電話</th>
          <th :style="{textAlign: 'start', width: '10em'}">統編</th>
          <th :style="{textAlign: 'start', width: '6em'}">縣市</th>
          <th :style="{textAlign: 'start', width: '6em'}">接洽窗口</th>
          <th :style="{textAlign: 'start', width: '14em'}">接洽電話</th>
          <th :style="{textAlign: 'center', width: '6em'}">目前綁定</th>
          <th :style="{textAlign: 'start', width: 'inherit'}">地址</th>
        </template>
        <tr slot-scope="{item: {tag,name,color,tel,head,headTel,address, country, linked, taxID, _id},index}" :style="{minHeight: '85px', height: '85px', borderBottom: 'none'}"
        @click="selected=(selected&&selected._id===_id)?null:rows[index];add=false">
          <td :style="{textAlign: 'start'}">
            <div class="type" :style="{minWidth: '4em', minWidth: '100px', width: 'fit-content', backgroundColor: (tagColors[tag] || '#CACACA')}">{{tag || '未設定'}}</div>
          </td>
          <td :style="{textAlign: 'start'}">
            <div :style="{borderBottom: `7px solid ${color || '#CACACA'}`}">{{name}}</div>
          </td>
          <td :style="{textAlign: 'start'}" v-html="tel?.join('<br>')"></td>
          <td :style="{textAlign: 'start'}">{{taxID}}</td>
          <td :style="{textAlign: 'start'}">{{country}}</td>
          <td :style="{textAlign: 'start'}">{{head}}</td>
          <td :style="{textAlign: 'start'}">{{headTel}}</td>
          <td :style="{textAlign: 'center'}">{{linked?.length||'-'}}</td>
          <td :style="{textAlign: 'start'}">{{address}}</td>
        </tr>
      </T2>
    </L1>
    <info @close="selected=null" :item="selected" :partnerCategories="partnerCategories" :countries="countries" @updateItem="updateItem" :rolesmap="rolesmap"></info>
    <addNew @close="add=false" :add="add" :partnerCategories="partnerCategories" :countries="countries" @updateItem="addItem"></addNew>
    <EditCateVue :show="editCates" @close="editCates=false" :categories="partnerCategories" @cates="partnerCategories=$event"/>
  </div>
</template>

<script>
import EditCateVue from './editCate.vue'
import Info from './infoPartner.vue'
import addNew from './addPartner.vue'
import Round from '../../components/btn/round.vue'
import Search from '../../components/input/search.vue'
import L1 from '../../components/layout/L1.vue'
import T2 from '../../components/tables/t2.vue'
import { getapi } from '../../store/fetch'
import Page50 from '../../components/input/page.vue'
export default {
  components: { L1, Search, Round, T2, Info, addNew, Page50, EditCateVue },
  data () {
    return {
      editCates: false,
      editTicket: false,
      rows: [],
      count: 0,
      add: false,
      selected: null,
      rolesmap: [],
      countries: [],
      partnerCategories: [],
      tag: null,
      country: null,
      searchText: null,
      limit: 15,
      page: 1,
      tickets0: [],
      tickets: [],
      ticketsOrg: []
    }
  },
  async mounted () {
    this.partnerCategories = await getapi('selections/partnerCategories')
    await this.getdata()
    await this.getrolemap()
    this.countries = await getapi('selections/country')
  },
  watch: {
    searchText () {
      this.getdata()
    },
    country () {
      this.getdata()
    },
    page () {
      this.getdata()
    },
    tag () {
      this.getdata()
    }
  },
  computed: {
    tagColors () {
      return Object.assign({}, ...this.partnerCategories.map(({ name, color }) => { return { [name]: color } }))
    },
    max () {
      return Math.ceil(this.count / this.limit)
    }
  },
  methods: {
    async getrolemap () {
      const rolesmap = await getapi('selections/roles')
      console.log('rolesmap', rolesmap)
      this.rolesmap = Object.assign({}, ...rolesmap.map(e => { return { [e.key]: e.zh } }))
    },
    addItem (ev) {
      this.rows.splice(0, 0, ev)
      this.selected = ev
      this.add = false
    },
    updateItem (ev) {
      const index = this.rows.map(e => e._id).indexOf(ev._id)
      this.rows.splice(index, 1, ev)
      this.selected = ev
    },
    async getdata () {
      const params = { page: this.page, limit: this.limit, contract: 0 }
      if (this.country) params.country = this.country
      if (this.searchText) {
        params.search = this.searchText
      }
      if (this.tag) {
        params.tag = this.tag
      }
      const { data, count } = await getapi('partners?' + new URLSearchParams(params))
      this.rows = data
      this.count = count
    }
  }
}
</script>

<style lang="scss" scoped>
.ticket {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 18px;
  height: 40px;
  letter-spacing: .1em;
  font-size: 16px;
  input[type=checkbox] {
    width: 20px;
    height: 20px;
    accent-color: var(--color-pri);
  }
}
.tickets {
  max-height: 500px;
  overflow-y: auto;
  padding: 20px 40px;
}
.type {
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;
  height: 36px;
  padding: 5px 10px;
  border-radius: 3px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.note {
  width: 30px;
  height: 30px;
  background-image: url(/remark.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}
</style>
